export interface Link {
    url: string;
    label: string;
}

export interface RegionLink {
    title: string;
    links: Link[];
}

export type RegionKey = 'metropolitana' | 'valparaiso' | 'biobio';

export const regionData: Record<RegionKey, RegionLink[]> = {
	'metropolitana': [
		{ title: "Departamentos en venta", links: [
			{ url: "https://www.toctoc.com/venta/departamento/metropolitana/santiago", label: "Santiago" },
			{ url: "https://www.toctoc.com/venta/departamento/metropolitana/las-condes", label: "Las Condes" },
			{ url: "https://www.toctoc.com/venta/departamento/metropolitana/nunoa", label: "Ñuñoa" },
			{ url: "https://www.toctoc.com/venta/departamento/metropolitana/vitacura", label: "Vitacura" }
		]},
		{ title: "Departamentos en arriendo", links: [
			{ url: "https://www.toctoc.com/arriendo/departamento/metropolitana/santiago", label: "Santiago" },
			{ url: "https://www.toctoc.com/arriendo/departamento/metropolitana/estacion-central", label: "Estación Central" },
			{ url: "https://www.toctoc.com/arriendo/departamento/metropolitana/las-condes", label: "Las Condes" },
			{ url: "https://www.toctoc.com/arriendo/departamento/metropolitana/nunoa", label: "Ñuñoa" }
		]},
		{ title: "Casas en venta", links: [
			{ url: "https://www.toctoc.com/venta/casa/metropolitana/colina", label: "Colina" },
			{ url: "https://www.toctoc.com/venta/casa/metropolitana/las-condes", label: "Las Condes" },
			{ url: "https://www.toctoc.com/venta/casa/metropolitana/lo-barnechea", label: "Lo Barnechea" },
			{ url: "https://www.toctoc.com/venta/casa/metropolitana/maipu", label: "Maipú" }
		]},
		{ title: "Casas en arriendo", links: [
			{ url: "https://www.toctoc.com/arriendo/casa/metropolitana/colina", label: "Colina" },
			{ url: "https://www.toctoc.com/arriendo/casa/metropolitana/lo-barnechea", label: "Lo Barnechea" },
			{ url: "https://www.toctoc.com/arriendo/casa/metropolitana/las-condes", label: "Las Condes" },
			{ url: "https://www.toctoc.com/arriendo/casa/metropolitana/vitacura", label: "Vitacura" }
		]}
	],
	'valparaiso': [
		{ title: "Departamentos en venta", links: [
			{ url: "https://www.toctoc.com/venta/departamento/valparaiso/vina-del-mar", label: "Viña del Mar" },
			{ url: "https://www.toctoc.com/venta/departamento/valparaiso/concon", label: "Concón" },
			{ url: "https://www.toctoc.com/venta/departamento/valparaiso/valparaiso", label: "Valparaíso" },
			{ url: "https://www.toctoc.com/venta/departamento/valparaiso/algarrobo", label: "Algarrobo" }
		]},
		{ title: "Departamentos en arriendo", links: [
			{ url: "https://www.toctoc.com/arriendo/departamento/valparaiso/vina-del-mar", label: "Viña del Mar" },
			{ url: "https://www.toctoc.com/arriendo/departamento/valparaiso/concon", label: "Concón" },
			{ url: "https://www.toctoc.com/arriendo/departamento/valparaiso/valparaiso", label: "Valparaíso" },
			{ url: "https://www.toctoc.com/arriendo/departamento/valparaiso/quilpue", label: "Quilpué" }
		]},
		{ title: "Casas en venta", links: [
			{ url: "https://www.toctoc.com/venta/casa/valparaiso/vina-del-mar", label: "Viña del Mar" },
			{ url: "https://www.toctoc.com/venta/casa/valparaiso/villa-alemana", label: "Villa Alemana" },
			{ url: "https://www.toctoc.com/venta/casa/valparaiso/quilpue", label: "Quilpué" },
			{ url: "https://www.toctoc.com/venta/casa/valparaiso/valparaiso", label: "Valparaíso" }
		]},
		{ title: "Casas en arriendo", links: [
			{ url: "https://www.toctoc.com/arriendo/casa/valparaiso/vina-del-mar", label: "Viña del Mar" },
			{ url: "https://www.toctoc.com/arriendo/casa/valparaiso/zapallar", label: "Zapallar" },
			{ url: "https://www.toctoc.com/arriendo/casa/valparaiso/concon", label: "Concón" },
			{ url: "https://www.toctoc.com/arriendo/casa/valparaiso/valparaiso", label: "Valparaíso" }
		]}
	],
	'biobio': [
		{ title: "Departamentos en venta", links: [
			{ url: "https://www.toctoc.com/venta/departamento/biobio/concepcion", label: "Concepción" },
			{ url: "https://www.toctoc.com/venta/departamento/biobio/san-pedro-de-la-paz", label: "San Pedro de la Paz" },
			{ url: "https://www.toctoc.com/venta/departamento/biobio/los-angeles", label: "Los Ángeles" },
			{ url: "https://www.toctoc.com/venta/departamento/biobio/chiguayante", label: "Chiguayante" }
		]},
		{ title: "Departamentos en arriendo", links: [
			{ url: "https://www.toctoc.com/arriendo/departamento/biobio/concepcion", label: "Concepción" },
			{ url: "https://www.toctoc.com/arriendo/departamento/biobio/san-pedro-de-la-paz", label: "San Pedro de la Paz" },
			{ url: "https://www.toctoc.com/arriendo/departamento/biobio/los-angeles", label: "Los Ángeles" },
			{ url: "https://www.toctoc.com/arriendo/departamento/biobio/talcahuano", label: "Talcahuano" }
		]},
		{ title: "Casas en venta", links: [
			{ url: "https://www.toctoc.com/venta/casa/biobio/san-pedro-de-la-paz", label: "San Pedro de la Paz" },
			{ url: "https://www.toctoc.com/venta/casa/biobio/concepcion", label: "Concepción" },
			{ url: "https://www.toctoc.com/venta/casa/biobio/los-angeles", label: "Los Ángeles" },
			{ url: "https://www.toctoc.com/venta/casa/biobio/chiguayante", label: "Chiguayante" }
		]},
		{ title: "Casas en arriendo", links: [
			{ url: "https://www.toctoc.com/arriendo/casa/biobio/los-angeles", label: "Los Ángeles" },
			{ url: "https://www.toctoc.com/arriendo/casa/biobio/san-pedro-de-la-paz", label: "San Pedro de la Paz" },
			{ url: "https://www.toctoc.com/arriendo/casa/biobio/concepcion", label: "Concepción" },
			{ url: "https://www.toctoc.com/arriendo/casa/biobio/chiguayante", label: "Chiguayante" }
		]}
	]
};

export const titles = ["Comprar", "Arrendar"];
export const staticLinks = [
	[
		{ url: "https://www.toctoc.com/venta/departamento", label: "Departamentos" },
		{ url: "https://www.toctoc.com/venta/casa", label: "Casas" },
		{ url: "https://www.toctoc.com/venta/terreno", label: "Terrenos" },
		{ url: "https://www.toctoc.com/venta/parcela", label: "Parcelas" }
	],
	[
		{ url: "https://www.toctoc.com/arriendo/departamento", label: "Departamentos" },
		{ url: "https://www.toctoc.com/arriendo/casa", label: "Casas" },
		{ url: "https://www.toctoc.com/arriendo/oficina", label: "Oficinas" },
		{ url: "https://www.toctoc.com/arriendo/local-comercial", label: "Locales comerciales" }
	]
];
